import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

class List extends React.PureComponent {
  static get propTypes() {
    return {
      className: PropTypes.string,
      emptyValue: PropTypes.node,
      hover: PropTypes.bool,
      itemClass: PropTypes.string,
      items: PropTypes.array.isRequired,
      striped: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      className: "",
      emptyValue: null,
      hover: false,
      itemClass: "",
      striped: false,
    };
  }

  constructor() {
    super();

    this.renderChildren = this.renderChildren.bind(this);
  }

  renderChildren(value, i) {
    const { itemClass } = this.props;

    return (
      <li key={i} className={`list-content ${itemClass}`}>
        {value}
      </li>
    );
  }

  render() {
    const { className, emptyValue, hover, items, striped } = this.props;
    const wrapperClass = classNames({
      hover,
      striped,
      "list-component": true,
      [className]: className,
    });

    return (
      <ul className={wrapperClass}>
        {items.length ? items.map(this.renderChildren) : emptyValue}
      </ul>
    );
  }
}

export { List };
